/* eslint-disable import/no-extraneous-dependencies */
// import sum from 'lodash/sum';
// import uniq from 'lodash/uniq';
// import uniqBy from 'lodash/uniqBy';
import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance } from "../../utils/axiosInstance"

const url = process.env.BACKEND_URL;
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  saveHotels: [],
  hotelCityList: [],
  hotelList: [],
  hotelDetail: [],
  hotelBookingResponse: [],
};

const slice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    //GET SAVEHOTELS
    getCityListSuccess(state, action) {
      state.isLoading = false;
      state.cityListRes = action.payload;
    },
    getActivityListSuccess(state, action) {
      state.isLoading = false;
      state.safariListRes = action.payload;
    },
    getActivityDetailsSuccess(state, action) {
      state.isLoading = false;
      state.safariDetailsRes = action.payload;
    },
    getBookingSuccess(state, action) {
      state.isLoading = false;
      state.safariBookingRes = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getCart,
  addToCart,
  resetCart,
  gotoStep,
  backStep,
  nextStep,
  deleteCart,
  createBilling,
  applyShipping,
  applyDiscount,
  increaseQuantity,
  decreaseQuantity,
} = slice.actions;

// ----------------------------------------------------------------------

//SAVEHOTELSBOOKINGS

export function getCityList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/activity/searchCity`, obj);
      dispatch(slice.actions.getCityListSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function activityList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/safari/listSafaris`, obj);
      dispatch(slice.actions.getActivityListSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.getActivityListSuccess(error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function activityDetails(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/safari/safariDetail`, obj);
      dispatch(
        slice.actions.getActivityDetailsSuccess(response.data.safariDetails)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function booking(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/booking/safari`, obj);
      dispatch(slice.actions.getBookingSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
